module.exports = __webpack_public_path__ + "img/keyboard_key_9.a067ef76.png";